module.exports = __webpack_public_path__ + "img/ep-planche-zigzag.17631656.jpg";